import React from 'react';

export const MmcStack = ({ children, gap, className = '', style, ...props }) => {
    const customStyle = gap ? { ...style, gap: `var(--mmc-sp-${gap})` } : style;
    return (
        <div
            className={`mmc-stack ${className}`}
            style={customStyle}
            {...props}
        >
            {children}
        </div>
    );
};

export const MmcGrid = ({ children, className = '', ...props }) => {
    return (
        <div className={`mmc-grid-auto ${className}`} {...props}>
            {children}
        </div>
    );
};
